import { render, staticRenderFns } from "./SetupPrefix.vue?vue&type=template&id=789a28f6&"
import script from "./SetupPrefix.vue?vue&type=script&lang=js&"
export * from "./SetupPrefix.vue?vue&type=script&lang=js&"
import style0 from "./SetupPrefix.vue?vue&type=style&index=0&id=789a28f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports